export const SITE_URL: string =
  (import.meta.env.VITE_SITE_URL as string | undefined) || 'https://usfanslink.skin';

export const BRAND_NAME = 'USFans Spreadsheet';

export const FAVICON_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg';

export const OG_IMAGE =
  'https://readdy.ai/api/search-image?query=A%20wide%20editorial%20flat%20lay%20of%20assorted%20streetwear%20merchandise%20including%20sneakers%20a%20denim%20jacket%20a%20cap%20and%20a%20backpack%20scattered%20artistically%20on%20a%20warm%20rust%20orange%20studio%20backdrop%20with%20soft%20directional%20light%20rich%20texture%20vibrant%20modern%20fashion%20aesthetic%20high%20detail&width=1600&height=900&seq=hero-usfans-02&orientation=landscape&nocache=true';